<app-station-tile [styleClass]="enabled ? 'empty-working-station' : 'disabled'" [isDisabled]="station.stationUsage.disabled"
  [suspended]="station.stationUsage.suspended" [selected]="selected"
  *ngIf="station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 0">

  <sc-padding>
    <sc-flex>
      <ng-container *ngIf="station?.stationUsage?.suspended || station?.stationUsage?.disabled">
        <sc-icon iconClass="fa-lock" *ngIf="station?.stationUsage?.suspended"></sc-icon>
        <sc-icon iconClass="fa-xmark" *ngIf="station?.stationUsage?.disabled"></sc-icon>
        <sc-content-spacer></sc-content-spacer>
      </ng-container>
      <div class="label">{{station.name}}</div>
    </sc-flex>
  </sc-padding>

</app-station-tile>

<app-station-tile [styleClass]="enabled ? 'used-working-station' : 'disabled'" [selected]="selected"
  *ngIf="station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 1">

  <sc-padding>
    <sc-flex>
      <ng-container *ngIf="station?.stationUsage?.transports.length > 0">
        <app-transport-scope-icon [scope]="transport.scope"></app-transport-scope-icon>
        <sc-content-spacer></sc-content-spacer>
      </ng-container>
      <div class="label">{{station.name}}</div>
    </sc-flex>
  </sc-padding>

</app-station-tile>

<app-station-tile [styleClass]="enabled ? 'waiting-area' : 'disabled'" [selected]="selected"
  *ngIf="station.stationType === stationType.WAITING_AREA">

  <sc-padding>
    <sc-flex>
      <ng-container *ngIf="station?.stationUsage?.suspended || station?.stationUsage?.disabled">
        <sc-icon iconClass="fa-lock" *ngIf="station?.stationUsage?.suspended"></sc-icon>
        <sc-icon iconClass="fa-xmark" *ngIf="station?.stationUsage?.disabled"></sc-icon>
        <sc-content-spacer></sc-content-spacer>
      </ng-container>
      <div class="label">{{station.name}}</div>
      <sc-content-spacer grow></sc-content-spacer>
      <div>{{station?.stationUsage?.transports?.length}} / {{station?.capacity}}</div>
    </sc-flex>
  </sc-padding>

</app-station-tile>
